export default __webpack_public_path__ + "static/media/330_portfolio04-it-mobile.499ffc95.png";